import { isAdInventoryTargetingEnabled } from '../formatInventoryTargeting'
import { getAllOrSpecificInventory } from '../../helpers'

import { AD_INVENTORY } from '../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

export const getPercentageAllocationInventoryToTarget = (values, right) => {
  const adInventoryTargetingEnabled = isAdInventoryTargetingEnabled(right)
  const allRightInventory = right[AD_INVENTORY] || []

  if (adInventoryTargetingEnabled) {
    // enabled - use helper to determine all or specific inventory
    return getAllOrSpecificInventory(values, right)
  } else {
    // when targeting is disabled - we don't show the inventory selection step, we just take all the inventory from right
    return allRightInventory
  }
}
